export default __webpack_public_path__ + "img/cdoeyhsb.b4246250.svg";